<template>
  <div>
    <old-html-detail-part v-if="type === 'detail'" :data="data" />
    <old-html-sku-picker-part v-else-if="type === 'picker'" :data="data" />
  </div>
</template>
<script>
import oldHtmlDetailPart from "./oldHtmlDetailPart.vue";
import OldHtmlSkuPickerPart from "./oldHtmlSkuPickerPart.vue";
export default {
  name: "OldHtmlPart",
  components: { oldHtmlDetailPart, OldHtmlSkuPickerPart },
  props: {
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
    type: {
      type: String,
      default: function () {
        return "";
      },
    },
  },
  data() {
    return {};
  },
  watch: {},
  created() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.delivery {
  line-height: 30px;
  margin-left: 42px;
  margin-bottom: 10px;
  img {
    width: 18px;
    height: 18px;
    vertical-align: middle;
  }
  img.pre-tag {
    width: 36px;
    height: 20px;
  }
  span {
    font-size: 14px;
    color: #666;
  }
}
</style>
